import { NUMERIC_STATISTIC_FIELDS } from './statisticsModel';

export const LIMITS_STORAGE_KEY = 'footskill-statistic-limits-v1';

export const STATISTIC_LIMIT_FIELDS = [
  ['Hit', 'Сила удара', 'км/ч'], ['Speed', '10 м с места', 'км/ч'],
  ['Speed2', '10 м с места', 'с'], ['Speed_s_razbega', '10 м с разбега', 'км/ч'],
  ['Speed_s_razbega2', '10 м с разбега', 'с'], ['Reaction', 'Реакция', 'мс'],
  ['Jump', 'Прыжок в высоту', 'см'], ['Jump2', 'Прыжок в длину', 'см'],
  ['sharpshooting', 'Точность', '%'], ['Agility', 'Agility test', 'с'],
  ['FootSkill', 'FootSkill test', 'с'], ['FootSkill2', 'FootSkill test', 'удары'],
  ['MessiTestDriblingTest', 'Messi test 1', 'с'], ['ExstraColorDriblingTest', 'Messi test 1', 'касания'],
  ['MessiTestDriblingTest2', 'Messi test 2', 'с'], ['ExstraColorDriblingTest2', 'Messi test 2', 'касания'],
];

export const readLimits = (storage = window.localStorage) => {
  try { return JSON.parse(storage.getItem(LIMITS_STORAGE_KEY) || '{}'); } catch (_error) { return {}; }
};

export const findStatisticViolations = (players = [], limits = {}) =>
  (players || []).flatMap((player) => (player.Statistics || []).flatMap((statistic, statisticIndex) =>
    NUMERIC_STATISTIC_FIELDS.flatMap((field) => {
      const limit = Number(limits[field]);
      const value = Number(statistic[field]);
      if (!Number.isFinite(limit) || limits[field] === '' || !Number.isFinite(value) || value <= limit) return [];
      return [{ player, statistic, statisticIndex, field, value, limit }];
    })
  ));

export const normalizeSearchText = (value = '') => String(value)
  .toLocaleLowerCase('ru-RU').replace(/\.[^.]+$/, '').replace(/\u0451/g, 'е')
  .replace(/[^a-zа-я0-9]+/gi, ' ').trim();

export const matchPhotoCandidates = (filename, players = []) => {
  const text = normalizeSearchText(filename);
  const compact = text.replace(/\s/g, '');
  return (players || []).map((player) => {
    const lastname = normalizeSearchText(player.lastname);
    const firstname = normalizeSearchText(player.firstname);
    const middlename = normalizeSearchText(player.middlename || player.patronymic);
    const full = [lastname, firstname, middlename].filter(Boolean).join(' ');
    const short = [lastname, firstname].filter(Boolean).join(' ');
    const phone = String(player.f_email || player.phone || '').replace(/\D/g, '');
    let score = 0;
    if (full && text === full) score = 100;
    else if (short && text === short) score = 90;
    else if (phone.length >= 7 && compact.includes(phone)) score = 85;
    else if (short && text.includes(short)) score = 75;
    else if (lastname && text.includes(lastname)) score = 60;
    return { player, score };
  }).filter((item) => item.score > 0).sort((a, b) => b.score - a.score);
};
